import Component from 'gia/Component'
import gsap from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import _each from 'lodash.foreach'


gsap.registerPlugin(ScrollTrigger);

class Project extends Component {

  constructor(element) {

    super(element)

    this.body = $('body')
    this.element = element
    $(this.element).data('project', this)
    this.name = this.element.dataset.index

    this.ref =  {
      about: null,
      open: null,
      close: null,
      left: null,
      right: null,
      current: null,
      images: null,
      total: null,
      li:[]
    }

  }

  mount() {



      this.current = 0
      this.length = this.ref.li.length

      $(this.ref.current).html(gsap.utils.wrap(0, this.length, this.current) + 1)
      $(this.ref.total).html(this.length)

      $(this.ref.open).on('click', (e)=>{
        e.preventDefault()
        $(this.element).addClass('has-about')
      })
      $(this.ref.close).on('click', (e)=>{
        e.preventDefault()
        $(this.element).removeClass('has-about')
      })

      this.bindedmove = this.move.bind(this)


  }


  move(i){
    i = 1

    let currentli = $(gsap.utils.wrap(this.ref.li, this.current))
    var video = currentli.find('video')
    if(video.length > 0){
      video[0].pause()
    }

    currentli.removeClass('active')

    this.current = this.current + i
    $(this.ref.current).html(gsap.utils.wrap(0, this.length, this.current) + 1)

    let nextli = $(gsap.utils.wrap(this.ref.li, this.current))

    var nvideo = nextli.find('video')
    if(nvideo.length > 0){

      this.delayed = gsap.delayedCall(5, this.bindedmove)
      nvideo[0].play()

    }
    nextli.addClass('active')

    if(nvideo.length == 0){
      this.delayed = gsap.delayedCall(3, this.bindedmove)
    }


  }

  start(isActive){



    !isActive && $('.has-about').removeClass('has-about');


    let currentli = $(gsap.utils.wrap(this.ref.li, this.current))
    var video = currentli.find('video')

    if(video.length > 0){

      if(isActive){


        this.delayed = gsap.delayedCall(3, this.bindedmove)
        video[0].play()
      }
      else {
        video[0].pause()
      }
    }

    if(isActive){
      if(video.length == 0){
        this.delayed = gsap.delayedCall(3, this.bindedmove)
      }
    }
    else {
      this.delayed && this.delayed.kill()
    }
  }

  unmount() {

      this.delayed && this.delayed.kill()

      this.bindedmove = null

  }


}

module.exports = Project
